export default "__VITE_ASSET__b4746bd0__"